import React, { createContext, useContext, useState, } from 'react';
export var View;
(function (View) {
    View["Menu"] = "menu";
    View["Speed"] = "speed";
    View["Quality"] = "quality";
    View["Subtitles"] = "subtitles";
})(View || (View = {}));
const ViewContext = createContext(null);
export const ViewProvider = ({ children }) => {
    const [view, setView] = useState(View.Menu);
    return (React.createElement(ViewContext.Provider, { value: {
            view,
            setView,
        } }, children));
};
export const useView = () => {
    const context = useContext(ViewContext);
    if (context === null) {
        throw new Error('ViewContext is null');
    }
    return context;
};
//# sourceMappingURL=ViewProvider.js.map